import { SURVEY_EDITOR_RATING_RIGHT_CHANGE_QUESTION_AND_LABEL } from "../../../../../constants";

export const RatingScaleChangeOptionQuestionAndLabel = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_RATING_RIGHT_CHANGE_QUESTION_AND_LABEL, payload });
    }
};